




























































































import {
  defineComponent,
  ref,
  onMounted,
  watch,
  PropType,
} from '@vue/composition-api';
import { Checkbox } from '@hb/coffee';
import { DownArrowOutline12 } from '@hb/coffee-icons';
import type { ChannelContractInfo, ChannelInfoExtend, ContractListItem } from '../type';
import { getContractIframeUrl, formatContractName } from '../utils';

export default defineComponent({
  name: 'ChannelContractList',
  components: {
    Checkbox,
    DownArrowOutline12,
  },
  props: {
    /** 渠道列表 */
    channelList: {
      type: Array as PropType<ChannelContractInfo[]>,
      required: true,
      default: () => [],
    },
    /** 是否支持展开功能（支持时会显示遮罩和展开按钮） */
    supportExpand: {
      type: Boolean,
      default: false,
    },
    /** 是否显示"获得更多额度"选项（第4个及以后的渠道） */
    showMoreAmountOption: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    'change-select',
    'change-contract',
    'expand-channel',
  ],
  setup(props, { emit }) {
    /** 本地渠道列表（添加交互状态） */
    const localChannelList = ref<ChannelInfoExtend[]>([]);

    /** 初始化渠道列表 */
    const initChannelList = () => {
      localChannelList.value = props.channelList.map((channel, index) => {
        // 保留已有的交互状态（如果存在）
        const existingChannel = localChannelList.value[index];
        return {
          ...channel,
          contractActive: existingChannel && existingChannel.contractActive !== undefined
            ? existingChannel.contractActive
            : 0, // 保留已选中的协议索引
          isExpand: existingChannel && existingChannel.isExpand !== undefined
            ? existingChannel.isExpand
            : false, // 保留展开状态
        };
      });

      // 只有一个授信渠道时默认展开
      if (props.channelList.length === 1
        && props.supportExpand
        && localChannelList.value[0]
        && !localChannelList.value[0].isExpand) {
        localChannelList.value[0].isExpand = true;
      }
    };

    /** 监听外部 channelList 的变化，同步更新内部状态 */
    watch(
      () => props.channelList,
      () => {
        initChannelList();
      },
      { deep: true },
    );

    /** 获取协议 iframe URL */
    const getIframeUrl = (channel: ChannelInfoExtend): string => {
      const { contractList = [] } = channel;
      if (contractList.length === 0) {
        return '';
      }
      const contract = contractList[channel.contractActive || 0];
      return getContractIframeUrl(contract.url, contract.type);
    };

    /** 选中/取消选中渠道 */
    const handleSelectChannel = (channel: ChannelInfoExtend) => {
      emit('change-select', {
        productId: channel.productId,
        isSelected: channel.isSelected,
      });
    };

    /** 协议切换 */
    const handleChangeContract = (
      channel: ChannelInfoExtend,
      index: number,
      contract: ContractListItem,
    ) => {
      channel.contractActive = index;
      emit('change-contract', {
        channel,
        contract,
        index,
      });
    };

    /** 展开渠道 */
    const handleExpandChannel = (channel: ChannelInfoExtend) => {
      if (!props.supportExpand) {
        return;
      }
      channel.isExpand = true;
      emit('expand-channel', {
        productId: channel.productId,
      });
    };

    onMounted(() => {
      initChannelList();
    });

    return {
      localChannelList,
      getIframeUrl,
      handleSelectChannel,
      handleChangeContract,
      handleExpandChannel,
      formatContractName,
    };
  },
});
